<template>
  <div>
    <div class="dh_p1a w-100">
      <div class="x_div_center" style="height: 100%; background-color: rgba(0, 0, 0, 0.3)">
        <div class="rp_set px-3" style="padding: 120px 0 0 0" v-if="lang == 'ko'">
          <span class="dh_p1b">프로젝트</span><br />
          <span class="dh_p1c">M3가 현재 진행하고있는 프로젝트들을 만나보세요.</span>
        </div>
        <div class="rp_set px-3" style="padding: 120px 0 0 0" v-else-if="lang == 'en'">
          <span class="dh_p1b">Projects</span><br />
          <span class="dh_p1c">Get information about M3's recently proceeding projects.</span>
        </div>
      </div>
    </div>

    <div class="x_div_center">
      <div class="rp_set">
        <div class="w-100 py-3 pt-5">
          <div class="x_div_center pb-3">
            <span class="fkr-set2 fs-16 fc-w10"><strong>{{ lang == "ko" ? menuName : menuNameEn }}</strong></span>
          </div>
          <div class="py-3 pt-5">
            <div v-for="(row, rowIdx) in showList" :key="rowIdx">
              <div class="iw-1 py-2 w-100">
                <div class="iw-5" v-for="(prj, colIdx) in row" :key="colIdx">
                  <a v-if="prj && prj.recentList && prj.recentList.length > 0" :href="'/menu/projects/dtl/' +
                    prj.recentList[0].recentId +
                    '?menuId=' +
                    $route.params.menuId
                    " style="width: 100%">
                    <div class="p-4">
                      <div class="x_div_center" style="overflow-x: hidden">
                        <img v-if="prj.thumbnailUrl" :src="prj.thumbnailUrl" height="250"
                          style="border: 1px solid #e9e9e9; width: auto" />
                      </div>
                      <div class="py-3">
                        <div>
                          <span class="fkr-set1 fs-09 x_div_center">
                            {{
                              prj.recentList && prj.recentList.length > 0 ? prj.sbjct : ""
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- 페이징 -->
          <div style="border-top: 1px solid #e9e9e9">
            <div class="x_div_center py-3" v-if="!fetching">
              <a class="px-2" @click="switchPage(-1)" style="cursor: pointer; margin-right: 10px"><i
                  class="fa-solid fa-angles-left"></i></a>
              <a class="px-2" @click="switchPage(0)" style="cursor: pointer; margin-right: 10px"><i
                  class="fa-solid fa-angle-left"></i></a>
              <span v-if="pageQueue[0] > 1" class="fen-set2" style="cursor: pointer; margin-right: 10px">...</span>
              <a v-for="index in pageQueue" :key="index" class="px-2" @click="
                currentPage = index;
              renderList();
              " style="margin-right: 10px"><span :class="'fen-set' + (currentPage == index ? '1' : '2')"
                  style="cursor: pointer">{{ index }}</span></a>
              <span v-if="pageQueue[pageQueue.length - 1] < numOfPage" style="cursor: pointer"
                class="fen-set2">...</span>
              <a class="px-2" @click="switchPage(1)" style="cursor: pointer; margin-right: 10px"><i
                  class="fa-solid fa-angle-right"></i></a>
              <a class="px-2" @click="switchPage(2)" style="cursor: pointer; margin-right: 10px"><i
                  class="fa-solid fa-angles-right"></i></a>
            </div>
          </div>

          <!-- 페이지 개선, 썸네일 형식으로, 아래는 이전의 아코디언 방식. - DeclanKim 2025.07.29 -->
          <!-- <div class="x_div_end" v-if="!isMobile">
                        <a v-if="!isMobile" :href="proxyUrl + '?redirect=' + encodeURIComponent('/admin/site/recent-list?projectId=0&menuId=' + $route.params.menuId)" target="_blank">
                            <span class="fkr-set1" style="margin-right: 15px;">
                                <i class="fas fa-pen"></i>
                            </span>
                        </a>
                    </div>

                    <div class="pg_m_set" v-if="fetching" style="padding: 20px">
                        <div class="x_div_center"><h3><i class='fa fa-spinner fa-spin'></i></h3></div>
                    </div>
                    <div v-else>
                        <div class="py-3">
                            <div style="border-top:1px solid #e7e7e7">
                                <div v-for="(project, index) in projectList" :key="index">
                                    <a :href="'#mfaq'+index" data-bs-toggle="collapse" role="button" aria-expanded="false" :aria-controls="'mfaq'+index">
                                        <div class="p-3 ls_bg1" style="display:flex; justify-content: space-between;">
                                            <span class="fkr-set1"><button class="fkr-set1 fc-w1" :style="'width:100px; height:26px; border:0; padding-top:0; margin-right:10px; background-color:hsl(' + (project.ctgry.id * 110)%360 + ', 100%, 30%)'" disabled>{{ lang == 'ko'? project.ctgry.ctgryName : project.ctgry.ctgryNameEn }}</button>{{project.sbjct}}</span>
                                            <span class="fkr-set2" style="padding-top: 2px;">{{project.crtDt.split('T')[0]}}
                                                <i class="fas fa-pen" v-if="!isMobile" style="margin-left: 15px" @click="redirectLink(proxyUrl + '?redirect=' + encodeURIComponent('/admin/site/recent-edit/0?projectId=' + project.recentPackageId))"/>
                                                <i class="fa fa-edit" v-if="!isMobile" style="margin-left: 15px" @click="redirectLink(proxyUrl + '?redirect=' + encodeURIComponent('/admin/site/recent-list?projectId=' + project.recentPackageId))"/>
                                            </span>
                                        </div>
                                    </a>
                                    <div :id="'mfaq'+index" class="collapse p-3" v-for="(recent, kintex) in project.recentList" :key="kintex" style="background-color:#f2f2f2; border-bottom:1px solid #e1e1e1">
                                        <a :href="'/menu/projects/dtl/' + recent.recentId + '?menuId=' + $route.params.menuId"><span class="fkr-set2">{{ recent.sbjct }}</span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
        </div>

        <MenuFooter v-if="lang == 'ko'" />
        <MenuFooter_En v-else-if="lang == 'en'" />
      </div>
    </div>
  </div>
</template>

<script>
import MenuFooter from "@/components/MenuFooter.vue";
import MenuFooter_En from "@/components/MenuFooterEn.vue";
import Api from "@/api";

const PAGESIZE = 9;

export default {
  name: "ProjectsList",
  props: {
    lang: {
      type: String,
      default: "ko",
    },
  },
  components: {
    MenuFooter,
    MenuFooter_En,
  },
  data() {
    return {
      fetching: true,
      isMobile: false,
      // news.vue처럼 그리드로 출력하기 위한 데이터 - DeclanKim 2025.07.31
      projectList: [], // ← 원본 전체 1차원 배열로만 관리
      showList: [[]], // ← 3x3 출력용 이중 배열
      currentPage: 1,
      pageQueue: [],
      numOfPage: 0,

      menuName: "",
      menuNameEn: "",
      buildMode: process.env.NODE_ENV,
      proxyUrl:
        (process.env.NODE_ENV == "local"
          ? "http://localhost:1025"
          : process.env.NODE_ENV == "development"
            ? "https://platform.buildmarket.kr"
            : "https://buildmarket.kr") + "/proxypage",
    };
  },
  async created() {
    this.fetchProjectList();
    this.fetching = false;
  },
  mounted() {
    this.isMobile = window.innerWidth < 768;
  },
  methods: {
    async fetchProjectList() {
      this.fetching = true;
      const apiUrl =
        (this.buildMode == "local"
          ? ""
          : this.buildMode == "development"
            ? "https://platform.buildmarket.kr"
            : "https://buildmarket.kr") + "/api/v1/recent/find/project/list";
      const rtnval = await Api.post(apiUrl, {
        recentMenuId: this.$route.params.menuId != "0" ? this.$route.params.menuId : null,
        asc: false,
      });
      if (rtnval.result) {
        this.projectList = rtnval.data.resultList;
        // 1. 대표이미지 비동기 패치
        await Promise.all(
          this.projectList.map(async (prj) => {
            let thumbnail = "";
            if (prj.recentList && prj.recentList.length > 0) {
              // 상세조회로 cntnt 불러오기
              const detailRes = await Api.post(
                (this.buildMode == "local"
                  ? ""
                  : this.buildMode == "development"
                    ? "https://platform.buildmarket.kr"
                    : "https://buildmarket.kr") + "/api/v1/recent/find/recent/dtl",
                { recentId: prj.recentList[0].recentId }
              );
              if (detailRes.result && detailRes.data.cntnt) {
                // 이미지 태그 파싱
                const match = detailRes.data.cntnt.match(
                  /<img[^>]*src=["']([^"']+)["']/i
                );
                if (match && match[1]) {
                  thumbnail = match[1];
                }
              }
            }
            // 결과를 각 prj에 저장 (반응성 보장하려면 Vue.set 써도 됨)
            prj.thumbnailUrl = thumbnail;
          })
        );
        // 대표 이미지가 없으면 제거 - DeclanKim 2025.07.31
        this.projectList = this.projectList.filter(prj => !!prj.thumbnailUrl);
        this.setPaging();
        this.renderList();
      } else {
        alert(rtnval.errormsg);
      }
      this.fetching = false;
    },

    redirectLink(link) {
      window.open("about:blank").location.href = link;
    },
    setPaging() {
      this.numOfPage = Math.ceil(this.projectList.length / PAGESIZE);
      this.pageQueue = [];
      // 페이지 큐 (10개씩) 기본 구현
      if (this.currentPage < 11) {
        for (let i = 1; i <= (this.numOfPage > 10 ? 10 : this.numOfPage); i++) {
          this.pageQueue.push(i);
        }
      } else {
        for (let i = this.currentPage - 9; i <= this.currentPage; i++) {
          this.pageQueue.push(i);
        }
      }
    },
    renderList() {
      const start = PAGESIZE * (this.currentPage - 1);
      const end = Math.min(start + PAGESIZE, this.projectList.length);
      this.showList = [[], [], []];
      let j = 0;
      let k = 0;
      for (let i = start; i < end; i++, k++) {
        if (k > 0 && k % 3 === 0) j++;
        this.showList[j][k % 3] = this.projectList[i];
      }
      // 빈칸 null 처리
      for (let x = 0; x < 3; x++)
        for (let y = 0; y < 3; y++) if (!this.showList[x][y]) this.showList[x][y] = null;
    },
    switchPage(mode) {
      let render = false;
      switch (mode) {
        case -1:
          if (this.currentPage > 1) {
            this.currentPage = 1;
            render = true;
          }
          break;
        case 0:
          if (this.currentPage > 1) {
            this.currentPage--;
            render = true;
          }
          break;
        case 1:
          if (this.currentPage < this.numOfPage) {
            this.currentPage++;
            render = true;
          }
          break;
        case 2:
          if (this.currentPage < this.numOfPage) {
            this.currentPage = this.numOfPage;
            render = true;
          }
          break;
      }
      if (render) {
        this.setPaging();
        this.renderList();
      }
    },
  },
};
</script>
